import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ViewSizeGuide } from '@yme/assets/icons';
import { FasletButtonStyled } from '@yme/pdp-components/Faslet/components/styled';
import { FASLET_SHOPPING_ID } from '@yme/pdp-components/Faslet/constants';
import { setFasletShoppingId, setIsWidgetShown } from '@yme/pdp-components/Faslet/redux/actions';
import { SizeGuideButton } from '@yme/pdp-components/ProductCard/components/SizeGuideButton/SizeGuideButton';
import { RegularTextLevel1 } from '@yme/tokens/typography';
export const FasletButton = ({ buttonLabel, shopId, handleClick, isShown, children, }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (shopId) {
            localStorage.setItem(FASLET_SHOPPING_ID, shopId);
        }
    }, [shopId]);
    useEffect(() => {
        dispatch(setFasletShoppingId(shopId));
    }, [dispatch, shopId]);
    useEffect(() => {
        dispatch(setIsWidgetShown(isShown));
        return () => {
            dispatch(setIsWidgetShown(false));
        };
    }, [dispatch, isShown]);
    return isShown ? (React.createElement(FasletButtonStyled, { key: "fasletButton", id: "faslet-button", onClick: handleClick },
        React.createElement("span", { id: "faslet-button-text" },
            React.createElement(SizeGuideButton, { asComponent: RegularTextLevel1, viewSizeGuideLabel: buttonLabel, viewSizeGuide: ViewSizeGuide })),
        children)) : null;
};
